// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1-2eO","signatureBlock":"Footer_signatureBlock__3mQT2","signature":"Footer_signature__3fTg4"};